"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const switch_styles_1 = require("@/components/common/switch/switch.styles");
const toggle_controller_1 = require("@/controllers/toggle-controller");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
let Switch = class Switch extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.checked = false;
        this.disabled = false;
        this.inputId = (0, utils_1.uniqueId)('switch');
        this.toggle = new toggle_controller_1.ToggleController(this, 'checked');
    }
    render() {
        return (0, lit_1.html) `
      <div>
        <input
          id=${this.inputId}
          name=${(0, if_defined_js_1.ifDefined)(this.name || undefined)}
          type="checkbox"
          role="switch"
          .checked=${this.checked}
          ?disabled=${this.disabled}
          @change=${this.handleInputChange}
        />
        <label for=${this.inputId}><slot></slot></label>
      </div>
    `;
    }
    handleInputChange(event) {
        const target = event.target;
        this.toggle.set(target.checked);
    }
};
Switch.styles = [shared_styles_1.resetStyles, switch_styles_1.switchStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Switch.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], Switch.prototype, "checked", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], Switch.prototype, "disabled", void 0);
Switch = __decorate([
    (0, decorators_js_1.customElement)('mm-switch')
], Switch);
exports.Switch = Switch;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3dpdGNoLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3dpdGNoLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFzQztBQUN0QyxxREFBMkQ7QUFDM0QsZ0VBQXdEO0FBRXhELDRFQUF1RTtBQUN2RSx1RUFBa0U7QUFDbEUsK0RBQXlEO0FBQ3pELG1DQUFrQztBQUczQixJQUFNLE1BQU0sR0FBWixNQUFNLE1BQU8sU0FBUSxnQkFBVTtJQUEvQjs7UUFFdUIsU0FBSSxHQUFHLEVBQUUsQ0FBQTtRQUNSLFlBQU8sR0FBRyxLQUFLLENBQUE7UUFDZixhQUFRLEdBQUcsS0FBSyxDQUFBO1FBQ3JDLFlBQU8sR0FBRyxJQUFBLGdCQUFRLEVBQUMsUUFBUSxDQUFDLENBQUE7UUFDNUIsV0FBTSxHQUFnQyxJQUFJLG9DQUFnQixDQUFDLElBQUksRUFBRSxTQUFTLENBQUMsQ0FBQTtJQXVCckYsQ0FBQztJQXJCQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7O2VBR0EsSUFBSSxDQUFDLE9BQU87aUJBQ1YsSUFBQSx5QkFBUyxFQUFDLElBQUksQ0FBQyxJQUFJLElBQUksU0FBUyxDQUFDOzs7cUJBRzdCLElBQUksQ0FBQyxPQUFPO3NCQUNYLElBQUksQ0FBQyxRQUFRO29CQUNmLElBQUksQ0FBQyxpQkFBaUI7O3FCQUVyQixJQUFJLENBQUMsT0FBTzs7S0FFNUIsQ0FBQTtJQUNILENBQUM7SUFFTyxpQkFBaUIsQ0FBQyxLQUFZO1FBQ3BDLE1BQU0sTUFBTSxHQUFHLEtBQUssQ0FBQyxNQUEwQixDQUFBO1FBQy9DLElBQUksQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsQ0FBQTtJQUNqQyxDQUFDOztBQTNCTSxhQUFNLEdBQUcsQ0FBQywyQkFBVyxFQUFFLDRCQUFZLENBQUMsQ0FBQTtBQUNmO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztvQ0FBVTtBQUNSO0lBQTVCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsQ0FBQzt1Q0FBZ0I7QUFDZjtJQUE1QixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLENBQUM7d0NBQWlCO0FBSmxDLE1BQU07SUFEbEIsSUFBQSw2QkFBYSxFQUFDLFdBQVcsQ0FBQztHQUNkLE1BQU0sQ0E2QmxCO0FBN0JZLHdCQUFNIn0=